import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22banner.tsx%22,%22import%22:%22Libre_Baskerville%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22700%22],%22display%22:%22swap%22,%22fallback%22:[%22Georgia%22,%22Times%20New%20Roman%22,%22serif%22]}],%22variableName%22:%22libreBaskerville%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Libre Baskerville', Georgia, Times New Roman, serif",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
